const init_status_observer = () => {
    let stepsWraper = document.querySelector('.steps-cont');
    if (stepsWraper === null) return;
    let bar_status = document.querySelector('.bar-status');
    if (bar_status === null) return;
  // create observer
  let stepsObserverCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let step = entry.target;
        const orientation = step.getAttribute('bar-orientation');
        bar_status.setAttribute('orientation', orientation);
      }
    });
  };
  let stepsObserverOptions = {
    root: stepsWraper,
    rootMargin: "0px",
    threshold: 0.5,
  };
  let stepsObserver = new IntersectionObserver(
    stepsObserverCallback,
    stepsObserverOptions
  );
  let stepsFocus = stepsWraper.querySelectorAll(".step");
  if (stepsFocus !== null) {
    stepsFocus.forEach((step) => stepsObserver.observe(step));
  }
};
export { init_status_observer };